export default {
  title: 'Créer un nouveau mot de passe',
  description: 'Créez un nouveau mot de passe pour votre compte.',
  form: {
    new_password: {
      label: 'Nouveau mot de passe',
      placeholder: 'Saisir le mot de passe',
      requirements: 'Votre mot de passe doit contenir 8 caractères, une majuscule et un chiffre',
    },
    confirm_password: {
      label: 'Confirmation du nouveau mot de passe',
      placeholder: 'Confirmer le mot de passe',
    },
    error_messages: {
      missing_info: 'Informations manquantes',
    },
  },
  buttons: {
    update_password: 'Mettre à jour le mot de passe',
  },
};
